import React, { useCallback, useEffect, useMemo, useState } from "react";
import * as RB from "react-bootstrap";
import DataTable from "react-data-table-component";
import FilterComponent from "../FilterComponent";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import DatePicker from "react-datepicker";
import { Delete, Visibility, Download, Store, Add } from "@mui/icons-material";
import * as utils from "../../Utils/comman";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../../reducers/userProfileSlice";
import { AddCircle, DocumentDownload, Edit2, Eye, Trash } from "iconsax-react";

function List(props) {
  console.log("Here is the props", props.id);
  let vendorType = "";
  const [formData, setFormData] = useState({
    vendorName: "",
    vendorQty: "",
    vendorDate: new Date(),
  });
  const [currentItem, setCurrentItem] = useState("");
  if (props.currentComp === "distributor") vendorType = "Distributor";
  else if (props.currentComp === "dealer") vendorType = "Dealer";
  else if (props.currentComp === "retailer") vendorType = "Retailer";
  else if (props.currentComp === "key-accounts") vendorType = "Key Accounts";
  else if (props.currentComp === "pro") vendorType = "PRO";
  const [itemList, setItemList] = useState([]);
  const [page, setPage] = useState(1);
  const dispatch = useDispatch();
  const [showExtendModal, setShowExtendModal] = useState(false);

  const countPerPage = 10;
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions
  );
  const userProfile = useSelector((state) => state?.userProfile?.userProfile);

  useEffect(() => {
    if (!userProfile) {
      dispatch(fetchUserProfile());
    }
  }, [userProfile]);

  const handleAddClick = (e) => {
    const propdata = {
      mode: "add",
    };
    props.onChange(propdata);
  };
  const columns = [
    {
      name: "Sr.No",
      selector: (row, index) => (page - 1) * countPerPage + index + 1,
      sortable: false,
      maxWidth: "80px", // Adjust the maximum width as needed
      minWidth: "60px",
    },
    {
      name: "Image",
      selector: (row) => row.item_image,
      cell: (row) => (
        <a href={row.item_image} target="_blank" rel="noopener noreferrer">
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "10px",
              overflow: "hidden",
              width: "60px",
              height: "60px",
            }}
          >
            <img
              src={row.item_image}
              alt={row.item_name}
              style={{ width: "80%", height: "80%" }}
            />
          </div>
        </a>
      ),
    },

    {
      name: "Item Name",
      selector: (row) => row.item_name,
    },
    {
      name: "Total Quantity",
      selector: (row) => row.Total_qty,
    },
    {
      name: "Available Quantity",
      selector: (row) => row.Available_qty,
    },

    // {
    //   name: "Price",
    //   selector: (row) => row.item_price,
    // },

    {
      name: "View",
      cell: (row) => (
        <>
          <RB.Button
            className="btn btn-flat"
            size="sm"
            onClick={handleView(row)}
          >
            <Eye />
          </RB.Button>
        </>
      ),
      center: true,
    },

    ...(utils.hasPermission(primaryMenuRes, "Pop Master", "pop_master.add_stock")
      ? [
          {
            name: <div>Add Stock</div>,
            cell: (row) => (
              <>
                <RB.Button
                  className="btn btn-flat"
                  size="sm"
                  onClick={() => handleAdd(row)}
                >
                  <AddCircle />
                </RB.Button>
              </>
            ),
            center: true,
          },
        ]
      : []),

    ...(utils.hasPermission(primaryMenuRes, "Pop Master", "pop_master.edit") ||
    utils.hasPermission(primaryMenuRes, "Pop Master", "pop_master.delete")
      ? [
          {
            name: "Action",
            center: true,
            cell: (row) => (
              <>
                {utils.hasPermission(
                  primaryMenuRes,
                  "Pop Master",
                  "pop_master.edit"
                ) && (
                  <RB.Button className="btn-flat" onClick={handelEdit(row)}>
                    <Edit2 />
                  </RB.Button>
                )}
                &nbsp;
                {utils.hasPermission(
                  primaryMenuRes,
                  "Pop Master",
                  "pop_master.delete"
                ) && (
                  <RB.Button className="btn-flat" onClick={showDelete(row)}>
                    <Trash />
                  </RB.Button>
                )}
              </>
            ),
          },
        ]
      : []),
  ];

  const resetFormData = () => {
    setFormData({
      vendorName: "",
      vendorQty: "",
      vendorDate: "",
    });
  };

  const handleAdd = (row) => {
    setCurrentItem(row);
    setShowExtendModal(true);
  };

  useEffect(() => {
    getItemList();
  }, [page, userProfile?.id, vendorType]);

  const getItemList = () => {
    var bodyFormData = new FormData();

    bodyFormData.append("id", "");
    bodyFormData.append("page", page);
    bodyFormData.append("per_page", countPerPage);

    utils
      .callAPI("post", `/sales/getmarketingList`, bodyFormData)
      .then((res) => {
        if (typeof res !== "undefined") {
          setItemList(res);
        } else {
          setItemList([]);
        }
      })
      .catch((err) => {
        setItemList([]);
      });
  };

  const handleExtendSubmit = () => {
    var bodyFormData = new FormData();

    bodyFormData.append("vendor_type", formData.vendorName);
    bodyFormData.append("vendor_qty", formData.vendorQty);
    bodyFormData.append(
      "vendor_date",
      moment(formData.vendorDate).format("YYYY-MM-DD")
    );
    bodyFormData.append("marketing_material_id", currentItem.id);

    utils
      .callAPI("post", "/sales/save_marketingstock_list", bodyFormData)
      .then((res) => {
        setShowExtendModal(false);
        resetFormData();
        getItemList();
      });
  };

  const handelEdit = useCallback((row) => async () => {
    const propdata = {
      mode: "edit",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const handleView = useCallback((row) => async () => {
    const propdata = {
      mode: "view",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const handleGodown = useCallback((row) => async () => {
    const propdata = {
      mode: "godown",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const showDelete = useCallback((row) => async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        utils
          .callAPI("post", `/sales/getmarketingDelete?id=${row.id}`)
          .then((res) => {
            if (typeof res !== "undefined") {
              getItemList();
            }
          })
          .catch((err) => {});
      }
    });
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let validatedValue = value;
    if (name === "vendorQty") {
      validatedValue = value.replace(/\D/g, "");
    }
    setFormData({
      ...formData,
      [name]: validatedValue,
    });
  };

  const handleDownload = () => {
    var bodyFormData = new FormData();

    bodyFormData.append("id", "");
    bodyFormData.append("page", 0);
    bodyFormData.append("per_page", 0);

    utils
      .callAPI("post", `/sales/getmarketingList`, bodyFormData)
      .then((res) => {
        if (typeof res !== "undefined") {
          const csvHeader =
            "Sr.No.,Item Name,Total Quantity,Available Quantity";
          const csvRows = res?.result?.map((leave, index) => {
            return `${index + 1},${leave.item_name},${leave.Total_qty},${
              leave.Available_qty
            }`;
          });

          const csvContent = [csvHeader, ...csvRows].join("\n");
          generateCSV(csvContent, "Pop Gift.csv");
          setItemList(res);
        } else {
        }
      })
      .catch((err) => {});
  };

  function generateCSV(filteredData, fileName) {
    const blob = new Blob([filteredData], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  const handleIncomeOutcome = () => {
    const propdata = {
      mode: "view",
      rowData: {},
    };
    props.onChange(propdata);
  };

  return (
    <div className="section-body">
      <RB.Card className="card shadow">
        <div className="floating-btns-holder-artisan">
          {utils.hasPermission(
            primaryMenuRes,
            "Pop Master",
            "pop_master.create"
          ) && (
            <a
              href
              className="btn btn-dark btn-circle"
              variant="dark"
              onClick={handleAddClick}
            >
              <AddCircle />
            </a>
          )}
          <RB.Button
            size="sm"
            variant="primary"
            className="btn-circle ms-2"
            onClick={handleDownload}
            disabled={itemList.result?.length == 0}
          >
            <DocumentDownload />
          </RB.Button>
        </div>
        <RB.Card.Header>
          <h4></h4>
          <div className="card-header-action">
            <RB.Button
              variant="primary"
              className="ms-2"
              onClick={handleIncomeOutcome}
            >
              Pop Gift Incoming/Outgoing
            </RB.Button>
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          {utils.hasPermission(
            primaryMenuRes,
            "Pop Master",
            "pop_master.view"
          ) && (
            <DataTable
              columns={columns}
              data={itemList.result}
              highlightOnHover
              responsive
              pagination
              paginationServer
              paginationTotalRows={itemList.total}
              paginationPerPage={countPerPage}
              paginationComponentOptions={{
                noRowsPerPage: true,
              }}
              striped
              onChangePage={(page) => setPage(page)}
              persistTableHead
              customStyles={{
                head: {
                  style: {
                    fontSize: "0.875rem", // Adjust the font size as needed
                    fontWeight: "bold", // Adjust the font weight as needed
                  },
                },
              }}
              // subHeader
              // subHeaderComponent={subHeaderComponent}
            />
          )}
        </RB.Card.Body>
      </RB.Card>

      <RB.Modal
        show={showExtendModal}
        onHide={() => {
          resetFormData();
          setShowExtendModal(false);
        }}
      >
        <RB.Modal.Header closeButton>
          <RB.Modal.Title>Add Stock</RB.Modal.Title>
        </RB.Modal.Header>
        <RB.Modal.Body>
          <RB.Form>
            <RB.InputGroup>
              <RB.Row>
                <RB.Col md={12}>
                  <div className="mb-3">
                    <RB.FloatingLabel
                      label="Vendor Name"
                      className="floating-label-fancy"
                    >
                      <RB.Form.Control
                        type="text"
                        placeholder="Enter Vendor Name"
                        name="vendorName"
                        value={formData.vendorName}
                        onChange={handleInputChange}
                        required
                      />
                    </RB.FloatingLabel>
                  </div>
                </RB.Col>

                <RB.Col md={4}>
                  <div className="mb-3">
                    <RB.FloatingLabel
                      label="Quantity"
                      className="floating-label-fancy"
                    >
                      <RB.Form.Control
                        type="text"
                        placeholder="Enter Quantity"
                        name="vendorQty"
                        value={formData.vendorQty}
                        onChange={handleInputChange}
                        required
                      />
                    </RB.FloatingLabel>
                  </div>
                </RB.Col>

                <RB.Col md={8}>
                  <div className="mb-3 mt-3">
                    <RB.FloatingLabel
                      // label="Join Date"
                      className="floating-label-fancy"
                    >
                      <DatePicker
                        selected={formData.vendorDate}
                        onChange={(date) =>
                          setFormData({ ...formData, vendorDate: date })
                        }
                        dateFormat="dd-MM-yyyy"
                        className="form-control"
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        placeholderText="Select Receving Date"
                        required
                        maxDate={moment().toDate()}
                      />
                    </RB.FloatingLabel>
                  </div>
                </RB.Col>
              </RB.Row>
            </RB.InputGroup>
          </RB.Form>
        </RB.Modal.Body>
        <RB.Modal.Footer>
          <RB.Button
            variant="secondary"
            onClick={() => {
              resetFormData();
              setShowExtendModal(false);
            }}
          >
            Close
          </RB.Button>
          <RB.Button variant="primary" onClick={handleExtendSubmit}>
            Save Changes
          </RB.Button>
        </RB.Modal.Footer>
      </RB.Modal>
    </div>
  );
}

export default List;
